import { Component, EventEmitter, Output, inject } from '@angular/core';
import { ModuleManagerService } from '../../services/module-manager.service';
import { INavigationItem } from '../../model/i-navigation-item';
import { CoreService } from '../../services/core.service';
import { ModuleEntryPointDefinition as ModuleEntryPointDefinition } from '../../model/module-entry-point-definition';
import { NavigationService } from '../../services/navigation.service';
import { CORE_NAVIGATION_ITEMS } from '../../core.definition';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { ModuleIconComponent } from '../module-icon/module-icon.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
   selector: 'asc-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss'],
   imports: [
      CommonModule,
      FormsModule,
      MatIconModule,
      MatListModule,
      MatMenuModule,
      ModuleIconComponent
   ]
})
export class MenuComponent {
   private moduleManagerService = inject(ModuleManagerService);
   private navigationService = inject(NavigationService);

   @Output() public itemSelected = new EventEmitter();

   public version?: string;
   private activeEntryPoint?: ModuleEntryPointDefinition;

   public homeEntryPoint = new ModuleEntryPointDefinition({
      navigate: () => this.navigationService.navigateToHomeAsync()
   });
   public settingsEntryPoint = new ModuleEntryPointDefinition({
      navigate: () => this.navigationService.navigateToSettings()
   });


   constructor() {
      const coreService = inject(CoreService);

      this.version = coreService.clientConfiguration.version;
   }

   public get featureNavigationItems(): INavigationItem[] {
      return this.moduleManagerService.featureNavigationItems;
   }

   public get settingsNavigationItems(): INavigationItem[] {
      return this.moduleManagerService.settingsNavigationItems;
   }

   public navigateTo(entryPoint: ModuleEntryPointDefinition) {
      this.activeEntryPoint = entryPoint;
      this.itemSelected.emit();
      entryPoint?.navigate();
   }

   public isHomeActive(): boolean {
      return this.moduleManagerService.isFeatureNavigationItemActive(CORE_NAVIGATION_ITEMS.HOME);
   }

   public isFeatureActive(navigationItem: INavigationItem) {
      return this.moduleManagerService.isFeatureNavigationItemActive(navigationItem.id);
   }

   public isSettingsActive(): boolean {
      return this.moduleManagerService.isFeatureNavigationItemActive(CORE_NAVIGATION_ITEMS.SETTINGS);
   }
}
